module.exports = require('../dist/components/Columns/Column');
